import { Component, computed, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DokumentAfsendelseService } from '@features/dokumenter/afsendelse/dokument-afsendelse.service';
import dayjs from 'dayjs';
import { Button } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePicker } from 'primeng/datepicker';
import { InputText } from 'primeng/inputtext';
import { Message } from 'primeng/message';
import { ScrollPanel } from 'primeng/scrollpanel';
import { Select } from 'primeng/select';
import { DokumentAfsendelseSearchParams } from './dokument-afsendelse-search-params.model';
import { LetInputCprComponent } from '@shared/let-input-cpr/let-input-cpr.component';

@Component({
  selector: 'app-dokument-afsendelse-search',
  imports: [
    ReactiveFormsModule,
    CheckboxModule,
    Button,
    InputText,
    Message,
    ScrollPanel,
    DatePicker,
    Select,
    LetInputCprComponent
  ],
  templateUrl: './dokument-afsendelse-search.component.html',
  styleUrl: './dokument-afsendelse-search.component.css',
})
export class DokumentAfsendelseSearchComponent {
  dokAfsendelseService = inject(DokumentAfsendelseService);
  data = this.dokAfsendelseService.datasource.data;

  form = new FormGroup({
    startTidspunktDate: new FormControl(
      dayjs().subtract(20, 'minute').toDate()
    ),
    slutTidspunktDate: new FormControl(dayjs().add(5, 'minute').toDate()),
    cpr: new FormControl(),
    regnr: new FormControl(),
    status: new FormControl(),
  });

  afsendelseOptions = ['Sendt', 'IkkeSendt', 'Fejlet', 'Opgivet'];

  onClickSearch() {
    this.dokAfsendelseService.searchDokument({
      ...(this.form.value as DokumentAfsendelseSearchParams),
      fraDato: dayjs(this.form.value.startTidspunktDate).format(
        'YYYY-MM-DD HH:mm'
      ),
      tilDato: dayjs(this.form.value.slutTidspunktDate).format(
        'YYYY-MM-DD HH:mm'
      ),
    });
  }

  onClickReset() {
    this.form.reset();
  }

  noHits = computed(() => {
    return (
      this.dokAfsendelseService.datasource.isLoaded() &&
      this.data()?.totalRowCount == 0
    );
  });
}
